@if (_shouldDisplaySelectOrderEntryMessage) {
  <span style="font-weight: bold">
    <!-- {{ 'common.orderModificationSelectOrderEntry' | cxTranslate }}<br /><br /> -->
  </span>
}

@if ((superUser && forRefundFlow) && !_shouldDisplaySelectOrderEntryMessage) {
  <div>
    <!-- <strong style="color: red;">{{ 'orderModification.superUserMsg' | cxTranslate }} </strong> -->
  </div>
}

<form [formGroup]="form">
  @if(!usjCode){
    <table class="table" style="width: 100%; margin-top: 25px">
      <caption class="cx-visually-hidden">
        {{
        'cartItems.caption' | cxTranslate
        }}
      </caption>
      @if (hasHeader) {
        <thead>
          <tr>
            <th scope="col" class="cart-table-th"></th>
            <th scope="col" class="cart-table-th">
              {{ 'cartItems.description' | cxTranslate }}
            </th>
            <th scope="col" class="cart-table-th">
              {{ 'cartItems.quantity' | cxTranslate }}
            </th>
            <th scope="col" class="cart-table-th">
              {{ 'cartItems.date' | cxTranslate }}
            </th>
            @if (displayTicketID) {
              <th scope="col" class="cart-table-th">
                {{ 'cartItems.ticketID' | cxTranslate }}
              </th>
            }
            @if (displayProductUnitPrice) {
              <th scope="col" class="cart-table-th">
                {{ 'cartItems.productUnitPrice' | cxTranslate }}
              </th>
            }
            @if(!forRefundFlow){
              <th scope="col" class="cart-table-th">
                {{ 'orderModification.pricedifference' | cxTranslate }}
              </th>
            }
            @if (options.isSaveForLater) {
              <th scope="col" class="cart-table-th">
                {{ 'saveForLaterItems.stock' | cxTranslate }}
              </th>
            } @else {
              @switch (this.currentBaseSite) {
                @case ("b2bportal") {
                  <th class="cart-table-th">
                    {{ 'cartItems.total' | cxTranslate }}
                  </th>
                }
                @default {
                  <th class="cart-table-th">
                    {{ 'cartItems.subTotal' | cxTranslate }}
                  </th>
                }
              }
            }
            @if (shouldDisplayNewVisitationDate) {
              <th scope="col" class="cart-table-th">
                {{ 'common.newVisitationDate' | cxTranslate }}
              </th>
            }
          </tr>
        </thead>
      }
      <tbody class="app-cart-item-list">
        @for (item of items; track item; let i = $index) {
          <tr [ngClass]="item.checkboxSelected ? 'border-bottom-0' : ''">
            <td class="cart-table-td">
              @if (orderEntrySelectionType === 'radio') {
                <input class="radio"type="radio" name="orderEntriesRadioButton" [(ngModel)]="orderEntryCheckboxSelected"
                  [value]="item.entryNumber" [ngModelOptions]="{ standalone: true }"
                  />
              }
              @if (orderEntrySelectionType === 'checkbox') {
                <input type="checkbox" name="orderEntriesRadioButton" [(ngModel)]="item.checkboxSelected"
                  [value]="item.entryNumber" [ngModelOptions]="{ standalone: true }"
                  (change)="checkboxSelectionChanged()" />
              }
            </td>
            <td class="cart-table-td">
              <div class="container">
                <!-- Item Image -->
                <div>
                <a [routerLink]="
                    { cxRoute: 'product', params: item.baseProduct ? item.baseProduct : item.product } | cxUrl
                  " tabindex="0">
                    <cx-media [container]="getImageForProduct(item)" format="cartIcon"
                    [alt]="$any(item).baseProduct ? $any(item).baseProduct.name : $any(item).product.name"></cx-media>
                  </a>
                  <div class="cx-info">
                    <div class="cx-name">
                    <a class="cx-link" [routerLink]="
                        { cxRoute: 'product', params: item.baseProduct ? item.baseProduct : item.product } | cxUrl
                      ">{{ item.baseProduct ? item.baseProduct.name : item.product?.name }}</a>
                    </div>
                    <div class="cx-code">
                      {{ 'cartItems.id' | cxTranslate }}
                      {{ item.baseProduct ? item.baseProduct.code : item.product?.code }}
                    </div>
                  </div>
                </div>
              </div>
            </td>
            @if (item.variants) {
              <td class="cart-table-td">
                @for (option of item.variantOptions; track option) {
                  <div class="row container m-2 mt-4">
                    <!-- option is Order Entry of Variant Product-->
                    <div class="col-12">
                      <label class="group-type">
                        {{ option.product?.name }}
                        <br/>
                        <small class="group-type-age-label">{{
                          'pdp.ageGroup.' + option.product?.ageCategory | cxTranslate
                        }}</small>
                      </label>
                    </div>
                    <div class="col-12">
                    </div>
                    @if (!readonly) {
                      <div class="col-12">
                        @if(currentBaseSite == 'b2bportal'){
                          <small class="group-type-age-label">
                            @if (option.product?.minQty) {
                              <b>{{
                                'common.productMinVal' | cxTranslate : { minVal: option.product?.minQty }
                              }}</b>
                            }
                            @if (option.product?.minQty && option.product?.maxQty) {
                              <b>, </b>
                            }
                            @if (option.product?.maxQty) {
                              <b>{{
                                'common.productMaxVal' | cxTranslate : { maxVal: option.product?.maxQty }
                              }}</b>
                            }
                          </small>
                        }
                      </div>
                    }
                  </div>
                }
              </td>
            } @else {
              <td class="cart-table-td">
                <div class="row container m-2 mt-4">
                  @if (item.product?.ageCategory) {
                    <div class="col-12">
                      <label class="group-type">
                        {{ item.product?.name }}
                        <br/>
                        <small class="group-type-age-label">{{
                          'pdp.ageGroup.' + item.product?.ageCategory | cxTranslate
                        }}</small>
                      </label>
                    </div>
                  }
                  <div class="col-12">
                    <app-item-counter [min]="convertQty(item.product?.minQty!)" [max]="convertQty(item.product?.maxQty!)"
                  [readonly]="true" [control]="
                    item.variantGroupingCode
                      ? $any(form.get(item.product?.code! + item.variantGroupingCode))
                      : $any(form.get(item.product?.code!))
                  " (quantityChanged)="onQuantityChangedNonVariant($event, item)">
                    </app-item-counter>
                  </div>
                </div>
              </td>
            }
            <td class="cart-table-td">
              <div>{{ item.selectedDateToVisit |cxDate :'MM/dd/yyyy' }}&nbsp;{{ (item?.product?.timeSelectionRequired ? item?.selectedTimeSlot : '')  }}</div>
              <!-- <div>{{ item.selectedDateToVisit |cxDate :'YYYY/MM/dd' }}&nbsp;{{ item.selectedTimeSlot }}</div> -->
            </td>
            @if (displayTicketID) {
              <td class="cart-table-td">
                <span style="white-space: pre-line">
                  {{ item.ticketCodesDisplayString }}
                </span>
              </td>
            }
            @if (displayProductUnitPrice) {
              <td class="cart-table-td">
                <span style="white-space: pre-line">
                  {{ item.unitPriceDisplayString }}
                </span>
              </td>
            }
            @if(!forRefundFlow){
              <td  class="cart-table-td">
                {{ getPriceDifferenceTotalForOrderEntry(item)  | currency:defaultCurrencyISO }}
              </td>
            }
            @if (item.combinedVariantPrice | async) {
              <td class="cart-table-td">
                <div>{{ item.combinedVariantPrice | async | currency: defaultCurrencyISO}}</div>
              </td>
            } @else {
              <td class="cart-table-td">
                <div>
                  {{ item.totalPrice?.formattedValue }}
                </div>
              </td>
            }
            @if (shouldDisplayNewVisitationDate) {
              <td class="cart-table-td">
                <div>
                  @if (item.selectedDateToVisit) {
                    <div class="col">
                      <label class="label-font-cart">
                        {{ 'pdp.selectVisitationDate' | cxTranslate }}
                      </label>
                      <mat-form-field style="max-width: 150px" appearance="fill">
                        <input matInput [matDatepickerFilter]="dateFilter" [matDatepicker]="dp" [readonly]="true"
                    [formControl]="
                      $any(form).get((item.baseProduct ? item.variantGroupingCode : item.product?.code) + '-date')
                    " (dateChange)="dateSelected($event, item)" />
                        <mat-datepicker-toggle matSuffix [for]="dp" (click)="onPickerToggle(item)"></mat-datepicker-toggle>
                        <mat-datepicker #dp [disabled]="false"></mat-datepicker>
                      </mat-form-field>
                      @if (item.isLoadingDates) {
                        <mat-spinner></mat-spinner>
                      }
                    </div>
                  }
                  @if (item.selectedTimeSlot && item?.product?.timeSelectionRequired) {
                    <div class="col">
                      <label class="label-font-cart">
                        {{ 'pdp.selecttimeslot' | cxTranslate }}
                      </label>
                      <mat-form-field style="max-width: 150px" appearance="fill">
                        <mat-select placeholder="{{ item.selectedTimeSlot }}"
                    (selectionChange)="timeSlotSelected($event, item)" [formControl]="
                      $any(form.get((item.baseProduct ? item.variantGroupingCode : item.product?.code) + '-time'))
                    " name="time" [disabled]="false" [value]="getDefaultTimeSlot(item.timeSlots, item)">
                          @for (time of item.timeSlots; track time) {
                            <mat-option [value]="time">
                              {{ time }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  }
                </div>
              </td>
            }
          </tr>
          @if (item.checkboxSelected) {
            <tr>
              <td colspan="100%">
                <div class="row p-2">
                  <div class="col-2 text-center font-weight-bolder">
                    {{ 'common.updateRequired' | cxTranslate }}
                  </div>
                  <div class="col-2 text-center font-weight-bolder">
                    {{ 'common.ticketCode' | cxTranslate }}
                  </div>
                  <div class="col-2 text-center font-weight-bolder">
                    {{ 'common.status' | cxTranslate }}
                  </div>
                  @if (forRefundFlow) {
                    <div class="col-2 text-center font-weight-bolder">
                      {{ 'common.refundEligible' | cxTranslate }}
                    </div>
                  }
                  @if (forRefundFlow) {
                    <div class="col-2 text-center font-weight-bolder">
                      {{ 'orderModification.servicefee' | cxTranslate }}
                    </div>
                  }
                  @if (forRefundFlow) {
                    <div class="col-2 text-center font-weight-bolder">
                      {{ 'common.cancellationServiceFee' | cxTranslate }}
                    </div>
                  }
                </div>
                @for (subEntry of item.subEntries; track subEntry; let i = $index) {
                  <div class="row p-2" [ngClass]="validateIfDisabled(subEntry) ? 'bg-secondary' : ''">
                    <div class="col-2 text-center">
                      <!-- <mat-checkbox [(ngModel)]="subEntry.selected" [checked]="subEntry.selected" name="{{subEntry.ticketCode}}-checkbox" [disabled]=" subEntry.status!='CONFIRMED' ? 'true' : 'false'"></mat-checkbox> -->
                      <!-- Refund: {{subEntry.refundAble}}<br />
                      Exchange: {{subEntry.exchangeAble}} <br />
                      Upgrade: {{subEntry.upgradeAble}} -->
                      <mat-checkbox [checked]="subEntry.selected"
                        (change)="onSubEntrySelecitonChange($event, subEntry, item)"
                        [disabled]="validateIfDisabled(subEntry)" [disableRipple]="true">
                      </mat-checkbox>
                    </div>
                    <div class="col-2 text-center">{{ subEntry.ticketCode }}</div>
                    <div class="col-2 text-center">{{ subEntry.status }}</div>
                    @if (subEntry.refundAble) {
                      @if (forRefundFlow) {
                        <div class="col-2 text-center">{{ 'common.refundable' | cxTranslate }}</div>
                      }
                    } @else {
                      @if (forRefundFlow) {
                        <div class="col-2 text-center">{{ 'common.nonRefundable' | cxTranslate }}</div>
                      }
                    }
                    @if (forRefundFlow) {
                      <div class="col-2 text-center">
                        {{defaultCurrencySymbolForBaseStore}}{{ subEntry.refundServiceFee ? subEntry.refundServiceFee : 0 }}
                      </div>
                    }
                    @if (forRefundFlow) {
                      <div class="col-2 text-center">
                        {{defaultCurrencySymbolForBaseStore}}{{ subEntry.cancellationServiceFee ?
                        subEntry.cancellationServiceFee : 0 }}
                      </div>
                    }
                  </div>
                }
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  }

  @else {
  <table class="table" style="width: 100%; margin-top: 25px">
    <caption class="cx-visually-hidden">
      {{
      'cartItems.caption' | cxTranslate
      }}
    </caption>
    @if (hasHeader) {
      <thead>
        <tr>
          <th scope="col" class="cart-table-th"></th>
          @if (shouldDisplayDescriptionColumn) {
            <th scope="col" class="cart-table-th">
              {{ 'cartItems.description' | cxTranslate }}
            </th>
          }
          <th scope="col" class="cart-table-th">
            {{ 'cartItems.quantity' | cxTranslate }}
          </th>
          <th scope="col" class="cart-table-th">
            {{ 'cartItems.date' | cxTranslate }}
          </th>
          @if (displayTicketID) {
            <th scope="col" class="cart-table-th">
              {{ 'cartItems.ticketID' | cxTranslate }}
            </th>
          }
          @if (displayProductUnitPrice) {
            <th scope="col" class="cart-table-th">
              {{ 'cartItems.productUnitPrice' | cxTranslate }}
            </th>
          }
          @if (options.isSaveForLater) {
            <th scope="col" class="cart-table-th">
              {{ 'saveForLaterItems.stock' | cxTranslate }}
            </th>
          } @else {
            @switch (this.currentBaseSite) {
              @case ("b2bportal") {
                <th class="cart-table-th">
                  {{ 'cartItems.total' | cxTranslate }}
                </th>
              }
              @default {
                <th class="cart-table-th">
                  {{ 'cartItems.subTotal' | cxTranslate }}
                </th>
              }
            }
          }
          @if (shouldDisplayNewVisitationDate) {
            <th scope="col" class="cart-table-th">
              {{ 'common.newVisitationDate' | cxTranslate }}
            </th>
          }
        </tr>
      </thead>
    }
    <tbody class="app-cart-item-list">
      @for (item of items; track item; let i = $index) {
        <tr [ngClass]="item.checkboxSelected ? 'border-bottom-0' : ''">
          <td class="cart-table-td">
            @if (orderEntrySelectionType === 'radio') {
              <input
                type="radio"
                name="orderEntriesRadioButton"
                [(ngModel)]="orderEntryCheckboxSelected"
                [value]="item.entryNumber"
                [ngModelOptions]="{ standalone: true }"
                />
            }
            @if (orderEntrySelectionType === 'checkbox') {
              <input
                type="checkbox"
                name="orderEntriesRadioButton"
                [(ngModel)]="item.checkboxSelected"
                [value]="item.entryNumber"
                [ngModelOptions]="{ standalone: true }"
                (change)="checkboxSelectionChanged()"
                />
            }
          </td>
          @if (shouldDisplayDescriptionColumn) {
            <td class="cart-table-td">
              <div class="container">
                <!-- Item Image -->
                <div>
                  <a
                  [routerLink]="
                    { cxRoute: 'product', params: item.baseProduct ? item.baseProduct : item.product } | cxUrl
                  "
                    tabindex="0"
                    >
                    <cx-media
                      [container]="getImageForProduct(item)"
                      format="cartIcon"
                      [alt]="$any(item).baseProduct ? $any(item).baseProduct.name : $any(item).product.name"
                    ></cx-media>
                  </a>
                  <div class="cx-info">
                    <div class="cx-name">
                      <a
                        class="cx-link"
                      [routerLink]="
                        { cxRoute: 'product', params: item.baseProduct ? item.baseProduct : item.product } | cxUrl
                      "
                        >{{ item.baseProduct ? item.baseProduct.name : item.product?.name }}</a
                        >
                      </div>
                      <div class="cx-code">
                        {{ 'cartItems.id' | cxTranslate }}
                        {{ item.baseProduct ? item.baseProduct.code : item.product?.code }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            }
            @if (item.variants) {
              <td class="cart-table-td">
                @for (option of item.variantOptions; track option) {
                  <div class="row container m-2 mt-4">
                    <!-- option is Order Entry of Variant Product-->
                    <div class="col-12">
                      <label class="group-type">
                        {{ option.product?.name }}
                        <br/>
                        <!-- <ng-container *ngIf="!appConstants.HIDE_AGE_CATEGORY_DISPLAY"> -->
                        <small class="group-type-age-label">{{'pdp.ageGroup.' + option.product?.ageCategory | cxTranslate}}</small>
                      <!-- </ng-container> -->
                    </label>
                  </div>
                  <div class="col-12">
                  </div>
                  @if (!readonly) {
                    <div class="col-12">
                      <small class="group-type-age-label">
                        @if (option.product?.minQty) {
                          <b>{{
                            'common.productMinVal' | cxTranslate : { minVal: option.product?.minQty }
                          }}</b>
                        }
                        @if (option.product?.minQty && option.product?.maxQty) {
                          <b>, </b>
                        }
                        @if (option.product?.maxQty) {
                          <b>{{
                            'common.productMaxVal' | cxTranslate : { maxVal: option.product?.maxQty }
                          }}</b>
                        }
                      </small>
                    </div>
                  }
                </div>
              }
            </td>
          } @else {
            <td class="cart-table-td">
              <div class="row container m-2 mt-4">
                @if (item.product?.ageCategory) {
                  <div class="col-12">
                    <label class="group-type">
                      {{ item.product?.name }}
                      <br/>
                      <small class="group-type-age-label">{{
                        'pdp.ageGroup.' + item.product?.ageCategory | cxTranslate
                      }}</small>
                    </label>
                  </div>
                }
                <div class="col-12">
                  <app-item-counter [min]="convertQty(item.product?.minQty!)" [max]="convertQty(item.product?.maxQty!)"
                  [readonly]="true" [control]="
                    item.variantGroupingCode
                      ? $any(form.get(item.product?.code! + item.variantGroupingCode))
                      : $any(form.get(item.product?.code!))
                  " (quantityChanged)="onQuantityChangedNonVariant($event, item)">
                  </app-item-counter>
                </div>
              </div>
            </td>
          }
          <td class="cart-table-td">
            <div>
              <!-- {{ udxValidators.convertGroupRulesDateFormat(item.selectedDateToVisit)  }}&nbsp;{{ item.selectedTimeSlot }} -->
              {{ item.selectedDateToVisit ? (item.selectedDateToVisit | dayjsFormat) : '' }}
            </div>
          </td>
          @if (displayTicketID) {
            <td class="cart-table-td">
              <span style="white-space: pre-line">
                {{ item.ticketCodesDisplayString }}
              </span>
            </td>
          }
          @if (displayProductUnitPrice) {
            <td class="cart-table-td">
              <span style="white-space: pre-line">
                {{ item.unitPriceDisplayString }}
              </span>
            </td>
          }
          @if (forRefundFlow) {
            @if (item.combinedVariantPrice | async; as allVariantsPriceCombined) {
              <td class="cart-table-td">
                <!-- combinedVariantPrice: -->
                <div>{{ allVariantsPriceCombined | currency: 'JPY' }}</div>
              </td>
            } @else {
              <td class="cart-table-td">
                <div>
                  <!-- totalPrice: -->
                  {{ item.totalPrice?.formattedValue }}
                </div>
              </td>
            }
          } @else {
            <td class="cart-table-td">
              <!-- combinedVariantPrice: -->
              <div>
                {{ (item.priceDifferenceForSelectedDate ? item.priceDifferenceForSelectedDate : 0)  | currency: 'JPY' }}
              </div>
            </td>
          }
          <ng-template #showZeroValue>
            <!-- USJT-15006: Total price to be set to 0 if the difference of price between visitation date and the target date is 0 -->
            <td class="cart-table-td">
              <div>
                <!-- Zero Value: -->
                {{ 0 | currency: 'JPY' }}
              </div>
            </td>
          </ng-template>
          @if (shouldDisplayNewVisitationDate) {
            <td class="cart-table-td">
              <div>
                @if (item.selectedDateToVisit) {
                  <div class="col">
                    <!-- <label class="label-font-cart">
                    {{ 'pdp.selectVisitationDate' | cxTranslate }}
                  </label> -->
                  <mat-form-field style="max-width: 150px" appearance="fill">
                    <input
                      matInput
                      [matDatepickerFilter]="dateFilter"
                      [matDatepicker]="dp"
                      [readonly]="true"
                    [formControl]="
                      $any(form).get((item.baseProduct ? item.variantGroupingCode : item.product?.code) + '-date')
                    "
                      (dateChange)="dateSelected($event, item)"
                      />
                    <mat-datepicker-toggle matSuffix [for]="dp" (click)="onPickerToggle(item)"></mat-datepicker-toggle>
                    <mat-datepicker #dp [disabled]="false"></mat-datepicker>
                  </mat-form-field>
                  @if (item.isLoadingDates) {
                    <mat-spinner></mat-spinner>
                  }
                </div>
              }
              @if (
                item.selectedTimeSlot&&
                (item.baseProduct ? item.baseProduct?.timeSelectionRequired : item.product?.timeSelectionRequired)) {
                <div class="col"> <!-- Raj: The timeSelectionRequired logic follows the condition for baseProduct vs item.product mentioned in the time selector element below -->
                  <mat-form-field style="max-width: 150px" appearance="fill">
                    <mat-select
                      placeholder="{{ item.selectedTimeSlot }}"
                      (selectionChange)="timeSlotSelected($event, item)"
                    [formControl]="
                      $any(form.get((item.baseProduct ? item.variantGroupingCode : item.product?.code) + '-time'))
                    "
                      name="time"
                      [disabled]="false"
                      [value]="getDefaultTimeSlot(item.timeSlots, item)"
                      >
                      @for (time of item.timeSlots; track time) {
                        <mat-option [value]="time">
                          {{ time }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
            </div>
          </td>
        }
      </tr>
      @if (item.checkboxSelected) {
        <tr>
          <td colspan="100%">
            <div class="row p-2">
              <div class="col-2 text-center font-weight-bolder">
                {{ 'common.updateRequired' | cxTranslate }}
              </div>
              <div class="col-3 text-center font-weight-bolder">
                {{ 'common.ticketCode' | cxTranslate }}
              </div>
              <div class="col-3 text-center font-weight-bolder">
                {{ 'common.status' | cxTranslate }}
              </div>
              @if (forRefundFlow) {
                <div class="col-2 text-center font-weight-bolder">
                  {{ 'common.refundEligible' | cxTranslate }}
                </div>
              }
              @if (forRefundFlow) {
                <div class="col-2 text-center font-weight-bolder">
                  {{ 'common.cancellationServiceFee' | cxTranslate }}
                </div>
              }
            </div>
            @for (subEntry of item.subEntries; track subEntry; let i = $index) {
              <div class="row p-2" [ngClass]="validateIfDisabled(subEntry) ? 'bg-secondary' : ''">
                <div class="col-2 text-center">
                  <mat-checkbox
                    [checked]="subEntry.selected"
                    (change)="onSubEntrySelecitonChange($event, subEntry, item)"
                    [disabled]="validateIfDisabled(subEntry)"
                    [disableRipple]="true"
                    >
                  </mat-checkbox>
                </div>
                <div class="col-3 text-center">{{ subEntry.ticketCode }}</div>
                <div class="col-3 text-center">{{ subEntry.locStatus }}</div>
                @if (subEntry.refundAble) {
                  @if (forRefundFlow) {
                    <div class="col-2 text-center">{{ 'common.refundable' | cxTranslate }}</div>
                  }
                } @else {
                  @if (forRefundFlow) {
                    <div class="col-2 text-center">{{ 'common.nonRefundable' | cxTranslate }}</div>
                  }
                }
                @if (forRefundFlow) {
                  <div class="col-2 text-center">
                    {{ (subEntry.cancellationServiceFee ? subEntry.cancellationServiceFee : 0) | currency: 'JPY' }}
                  </div>
                }
              </div>
            }
          </td>
        </tr>
      }
      <ng-template #noVariantsSecond>
        <td class="cart-table-td">
          <div class="row container m-2 mt-4">
            @if (item.product?.ageCategory) {
              <div class="col-12">
                <label class="group-type">
                  {{ item.product?.name }}
                  <br/>
                  <!-- <ng-container *ngIf="!appConstants.HIDE_AGE_CATEGORY_DISPLAY"> -->
                  <small class="group-type-age-label">{{'pdp.ageGroup.' + item.product?.ageCategory | cxTranslate}}</small>
                <!-- </ng-container> -->
                {{ item.variantGroupingCode
                ? $any(form.get(item.product?.code! + item.variantGroupingCode)?.getRawValue())
                : $any(form.get(item.product?.code!)?.getRawValue()) }}
                {{ 'cartItems.tickets' | cxTranslate}}
              </label>
            </div>
          }
        </div>
      </td>
    </ng-template>
  }
</tbody>
</table>

}
<br />
@if (forRefundFlow && this.usjCode) {
  {{ 'common.refundDescriptionMessage' | cxTranslate }}
  <hr />
}
</form>
